import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { amplitudeModule } from '@/modules/amplitude';
import {
  OnboardingOptionItem,
  OnboardingOptionsList,
} from '@/pages/Onboarding/components/List';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { nextStepTimeout } from '@/pages/Onboarding/utils/nextStepTimeout';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataType } from '../../types';

import { ContentContainer, PageStyles } from './SecretsAndDesires.styles.ts';

const SecretsAndDesiresOptions: {
  id: NonNullable<LayoutDataType['secrets_and_desires']>;
  title: string;
}[] = [
  {
    id: 'no',
    title: 'No',
  },
  {
    id: 'yes',
    title: 'Yes',
  },
];

export const SecretsAndDesires: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'SecretsAndDesires',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const secretsAndDesires = form.watch('secrets_and_desires');

  const handleChange = () => {
    nextStepTimeout(wizard.nextStep);
  };

  return (
    <PageStyles>
      <IonContent>
        <OnboardingNavigation />
        <ContentContainer>
          <OwnAiTitle className={'title'}>
            Things get intense and spicy here. Ready to keep it quiet?{' '}
          </OwnAiTitle>
          <OnboardingOptionsList direction={'row'}>
            {SecretsAndDesiresOptions.map((option) => (
              <OnboardingOptionItem
                checked={secretsAndDesires === option.id}
                control={form.control}
                option={option}
                name="secrets_and_desires"
                key={option.id}
                onChange={() => handleChange()}
                TEST_ID={`secrets_and_desires-${option.id}`}
                expand={true}
              />
            ))}
          </OnboardingOptionsList>
        </ContentContainer>
      </IonContent>
    </PageStyles>
  );
};
